export const PERMISSIONS_CONFIG = {
    dashboard: {
        title: 'Vista General',
        permissions: {
            canViewDashboard: 'Ver el dashboard principal con estadísticas.',
        }
    },
    pagos: {
        title: 'Gestión de Pagos',
        permissions: {
            canManagePayments: 'Aprobar y rechazar acuerdos de aporte.',
        }
    },
    financiero: {
        title: 'Finanzas y Registros',
        permissions: {
            canViewFinancialLog: 'Ver el registro financiero global.',
            canViewInvestmentDetails: 'Ver detalles de todas las participaciones.',
        }
    },
    reports: {
        title: 'Reportes',
        permissions: {
            canViewReports: 'Ver reportes y resúmenes de comisiones.',
        }
    },
    usuarios: {
        title: 'Gestión de Usuarios',
        permissions: {
            canManageUsers: 'Ver la lista de usuarios y sus permisos.',
            canEditUsers: 'Editar perfiles de usuario y añadir fondos manualmente.',
        }
    },
    retiros: {
        title: 'Gestión de Retiros',
        permissions: {
            canManageWithdrawals: 'Gestionar solicitudes de retiro de fondos.',
        }
    },
    planCarrera: {
        title: 'Recorrido Gerencial',
        permissions: {
            'panel:plan_carrera': 'Gestionar el progreso de socios, validar requisitos estructurales y entrega de premios físicos.',
        }
    },
    sistema: {
        title: 'Operaciones y Sistema',
        permissions: {
            canExecuteGlobalPayments: 'Ejecutar el proceso de pagos diarios globales.',
            canManageSmallOwners: 'Gestionar solicitudes para ser "Pequeño Dueño".',
            canUseUtilities: 'Acceder a herramientas de respaldo y migración de datos.',
        }
    }
};